<template>
	<div class="focusenterprises" >
		<leftnav class="fl" mkcode="E" itemcode="E-xlrxm" :mkopen="true"></leftnav>
		<div class="index_left" :style="isCollapse?'margin-left: 0;width:100%':''">
			<govheader></govheader>
			<div class="index_left_centerpage">
				<findProjectsTab :currentTab="'4'"></findProjectsTab>
				<div class="whitebox right_topbox" v-if="userdata.token" style="min-height:800px;">  
						<!-- 收藏列表的表格展示 --> 
					<div class="map_title_tab">
						<span :class="collectPageType != 'shortlist'?'title current':'title'" @click="collectPageToggle(collecttype)">{{curWebsite.type == 3 ? '域外招商' : '目标企业长名单'}}<em v-show="longListNum>0">({{longListNum}})</em></span>
						<span :class="collectPageType == 'shortlist'?'title current':'title'" v-show="curWebsite.type != 3" :data="collecttype" @click="collectPageToggle('shortlist')" >{{curWebsite.shortlistName}}<em v-show="shortListNum>0">({{shortListNum}})</em></span>
						<div v-show="userdata.groupType == 1" :class="exportbtn?'fr enlistexportbtn':'fr enlistexportbtn disable'" style="margin: 0;"
							@click="exportlistFun()" >
							<span><i class="el-icon-loading mr" v-show="exportLoading"></i>导出数据</span>
							</div> 
					</div>
					<div v-show="collectPageType == 'shortlist'">
						<!-- 短名单 -->
						<div class="collect_bigEns">
							<table border="0" cellspacing="0" cellpadding="0" class="enterprise_table">
								<tr>
									<th>排名</th>
									<th>企业名称</th>
									<th>地区</th>
									<th  v-for="(list,index) in dimesmlist"  :key="index">
										<div @click="tablesort(list.type);"  :style="'width:'+list.name.length*16+'px'" :class="{'td_sortname ':true,'current':orderField == list.type}" >
											<span		:class="{'sortname ':true,'current':orderField == list.type,'fz15':list.name.length>5}">{{list.name}}</span><span :class="orderType == 1?'timesorticon up':'timesorticon down'"></span>
										</div> 
										</th>
									<!-- <th>行业机会</th>
									<th>政策力度</th> -->
								<!-- 	<th>拿地数量</th>
									<th>拿地面积</th>
									<th>投资项目数量</th>
									<th>投资项目金额</th> -->
									<th>编辑</th>
								</tr>
								<tr v-for="(list,i) in shortenterlist" v-show="list.collectId>0" :key="i">
								 <td>{{i+1}}</td>
									<td class="title"		@click="routerlinkid('/enterprises',list.stockCode)">{{list.title}}</td>
									<td>{{list.area}}</td>
									<td>{{list.zs000000}}</td>
									<td>{{list.zs100000}}</td>
									<td>{{list.zs200000}}</td>  
								<!-- 	<td>{{list.zs300000}}</td> 
									<td>{{list.zs500000}}</td> -->
									<td>{{list.landCount}}</td>
									<td>{{list.landSize}}{{list.landSize>0?list.landSizeUnit:''}}</td>
									<td>{{list.investCount}}</td>
									<td>{{list.investMoney}}{{list.investMoney>0?list.investMoneyUnit:''}}</td>
									<td class="collectfont" style="width:200px">
										<!-- <span class="bde" v-show="list.enterpriseRelationType !=1 && !list.enterpriseRelationId" :data="list.enterpriseRelationId" @click="toggleRelationEnterprise(list,2)">加入想联系的企业</span> -->
										<!-- <span class="bde" v-show="list.enterpriseRelationType ==1 && list.enterpriseRelationId>0"  :data="list.enterpriseRelationId" @click="toggleRelationEnterprise(list,1)">移除我熟悉的企业</span> -->
										<span class="bde border-bottom" v-if="curWebsite.type!=4" :data="list.crmId" @click="crmtoggle(list,list.stockCode)">{{list.crmId ==0?'加入':'移除'}}项目管理</span>
										<span class="bde" @click="shortlistToggle(list.collectId,list.shortList,list);">{{list.shortList>0?'移除':'加入'}}短名单</span>
										<span	@click="cancelcollect(list.collectId,list,'all')">取消关注</span>
									</td>
								</tr>
							</table>
						</div> 
					</div>
					<div v-show="collectPageType != 'shortlist'">
						
						<ul class="user_tabtitle " style="margin-top: 10px;">
							<li v-for="(item,i) in tabtitle"  :key="i" :class="tabbtn==i?'current':''"	@click="tabbtnfun(item,i)">{{item.name}}<em v-show="item.num>0" class="num">({{item.num}})</em><em v-show="longListNum>0 && item.ctype == 0">({{longListNum}})</em></li> 
						</ul>
						
						<div class="usermg usercl_box"> 
							
							<!-- 龙头企业 创新企业 优质企业 上市企业 -->
							<div class="collect_bigEns" v-show="collecttype == 0 ||collecttype == 2 || collecttype == 10 || collecttype == 13 || collecttype == 1">
								<table border="0" cellspacing="0" cellpadding="0" class="enterprise_table">
									<tr>
										<th>排名</th>
										<th>企业名称</th>
										<th>地区</th>
										<th  v-for="(list,index) in dimesmlist"  :key="index">
											<div @click="tablesort(list.type);"  :style="'width:'+list.name.length*16+'px'" :class="{'td_sortname ':true,'current':orderField == list.type}" >
												<span		:class="{'sortname ':true,'current':orderField == list.type,'fz15':list.name.length>5}">{{list.name}}</span><span :class="orderType == 1?'timesorticon up':'timesorticon down'"></span>
											</div> 
											</th>
										<!-- <th>行业机会</th>
										<th>政策力度</th> -->
									<!-- 	<th>拿地数量</th>
										<th>拿地面积</th>
										<th>投资项目数量</th>
										<th>投资项目金额</th> -->
										<th>编辑</th>
									</tr>
									<tr v-for="(list,d) in tabtitle[tabbtn].list" v-show="list.collectId>0" :key="d">
										<td>{{d+1}}</td>
										<td class="title"		@click="routerlinkid('/enterprises',list.stockCode)">{{list.title}}</td>
										<td>{{list.area}}</td>
										<td>{{list.zs000000}}</td>
										<td>{{list.zs100000}}</td>
										<td>{{list.zs200000}}</td> 
										<!-- <td>{{list.zs300000}}</td> 
										<td>{{list.zs500000}}</td> -->
										<td>{{list.landCount}}</td>
										<td>{{list.landSize}}{{list.landSize>0?list.landSizeUnit:''}}</td>
										<td>{{list.investCount}}</td>
										<td>{{list.investMoney}}{{list.investMoney>0?list.investMoneyUnit:''}}</td>
										<td class="collectfont">
											<span class="bde" v-show="curWebsite.type != 3" @click="shortlistToggle(list.collectId,list.shortList,list)">{{list.shortList>0?'移除':'加入'}}短名单</span>
											<span	@click="cancelcollect(list.collectId,list,'all')">取消关注</span>
											<span @click="crmtoggle(list, list.stockCode)">{{ list.crmId == 0 ? '加入' : '移除' }}项目管理</span>
										</td>
									</tr>
								</table>
							</div> 
							<!-- 外资企业 -->
							<div class="collect_bigEns" v-show="collecttype == 16 ">
								<table border="0" cellspacing="0" cellpadding="0" class="enterprise_table">
									<tr>
										<th>序号</th>
										<th>企业名称</th>
										<th>地区</th> 
										<th>成立时间</th>
										<th>注册资本</th>
										<th>联系电话</th> 
										<th>编辑</th>
									</tr>
									 
									<tr v-for="(list,d) in forcapenterlist" :key="d">
										<td>{{d+1}}</td>
										<td class="title"		@click="routerlinkid('/enterprises',list.stockCode)">{{list.title}}</td>
										<td>{{list.area}}</td>
										<td>{{list.createTime}}</td>
										<td>{{list.regCapital}}</td>
										<td>{{list.phone}}</td>
										<!-- <td class="collectfont">
											<span class="bde" @click="shortlistToggle(list.collectId,list.shortList,list)">{{list.shortList>0?'移除':'加入'}}短名单</span>
											<span	@click="cancelcollect(list.collectId,list)">取消关注</span>
										</td> -->
										<td><span class="curp"		@click="cancelcollect(list.collectId,list)">取消关注</span></td>
									</tr>
								</table>
							</div> 
							<!-- 境外上市企业 -->
							<div class="collect_bigEns" v-show="collecttype == 18">
								<table border="0" cellspacing="0" cellpadding="0" class="enterprise_table">
									<tr>
										<th>序号</th>
										<th>名称</th>
										<th>代码</th>
										<th>交易平台</th> 
										<th>板块</th>
										<th>行业</th>
										<th>员工人数</th>
										<th>编辑</th>
									</tr> 
									 <tr v-for="(list,index) in foreignEnterList" v-show="list.collectId>0" :key="index">
									 	<td>{{index+1}}</td>
											<td class="title" @click="routerlinkid('/enterprisesF',list.id)">{{list.title}}</td>
									 	<td>{{list.stockCode}}</td>
									 	<td>{{list.exchangeTrans}}</td>
									 	<td>{{list.plate}}</td>
									 	<td>{{list.industry}}</td>
									 	<td>{{list.employee}}</td>
											<td><span class="curp"		@click="cancelcollect(list.collectId,list)">取消关注</span></td>
									 </tr>
								</table> 
							</div>
							<!-- 投资机构 -->
							<div class="collect_invorg" v-show="collecttype == 3">
								<table border="0" cellspacing="0" cellpadding="0" class="enterprise_table">
									<tr>
										<th>序号</th>
										<th>企业名称 </th>
										<!-- 	<th>投资领域</th>
								<th>画像标签</th> -->
										<th>创立日期</th>
										<!-- <th>进入下一轮项目数</th>  -->
										<th>机构类型</th>
										<th>地区</th>
										<th>管理规模</th>
										<th>编辑</th>
									</tr> 
										<!--  v-show="list.collectId>0" -->
									<tr v-for="(list,d) in orglist" :key="d">
									<td>{{d+1}}</td>
										<td class="title"		@click="routerlinkid('/investement-enterprises',list.id)">{{list.name}}</td> 
										<td>{{list.createTime}}</td>
										<td>{{list.type}}</td>
										<td>{{list.area}}</td>
										<td>
											<span v-if="list.asset != ''">{{list.asset}}</span>
											<span v-if="list.asset == ''">-</span>
										</td>
										<td><span class="curp"		@click="cancelcollect(list.collectId,list)">取消关注</span></td>
									</tr>
								</table>
							</div>
							<!-- 创新资源 -->
							<div class="collect_academy" v-show="collecttype == 4">
								<table border="0" cellspacing="0" cellpadding="0" class="enterprise_table">
									<tr>
										<th>序号</th>
										<th>企业名称 </th>
										<th>地区</th>
										<th>员工人数</th>
										<th>研究领域</th>
										<th>编辑</th>
									</tr>
									<tr v-for="(list,d) in academylist" v-show="list.collectId>0" :key="d">
									<td>{{d+1}}</td>
										<td class="title" @click="routerlinkid('/resources-enterprises',list.id)">	{{list.title}}</td>
										<td>{{list.area}}</td>
										<td>{{list.insurePerson}}</td>
										<td :class="list.notion == ''?'conpanytags':'conpanytags hastag'">
											<span class="span-tag" v-for="(item,s) in list.notionlist" :key="s"	@click="tagrouter('/enterpriseTag',7,'notion',item.id,item.name)">{{item.name}}</span>
											<i v-show="list.notionlist.length==0" style="color:#999">-</i>
										</td>
										<td><span class="curp"		@click="cancelcollect(list.collectId,list)">取消关注</span></td>
									</tr> 
								</table>
							</div>
							<!-- 产业园区 -->
							<table border="0" cellspacing="0" cellpadding="0" class="enterprise_table focuseprak_table" v-show="collecttype == 12 && this.userdata.edition>0"	>
								<tr>
									<th class="xuhaotd">序号</th>
									<th class="">园区名称</th>
									<th>省份</th>
									<th>城市</th>
									<th>地区</th> 
									<th>编辑</th>
								</tr>
								 <tr v-for="(item,i) in parkdata" v-show="item.collectId>0" :key="i">
								 	<td>{{i+1}}</td>
								 	<td class="title"	@click="routerlinkid('/industrialparkDetail',item.id)">{{item.parkName}}</td>
								 	<td>{{item.areaText.substring(0,3)}}</td>
								 	<td>
											<span v-if="item.areaText.substring(3,6) !=''">{{item.areaText.substring(3,6)}}</span>
												<span v-if="item.areaText.substring(3,6) ==''">-</span>
												</td>
								 	<td>
												<span v-if="item.areaText.substring(6,9) !=''">{{item.areaText.substring(6,9)}}</span>
												<span v-if="item.areaText.substring(6,9) ==''">-</span>
												</td>  
										<td><span class="curp"		@click="cancelcollect(item.collectId,item)">取消关注</span></td>
								 </tr>  
							</table>
							<!-- 协会 -->
							<table border="0" cellspacing="0" cellpadding="0" class="enterprise_table" v-show="collecttype == 14">
								<tr>
									<th class="xuhaotd">序号</th>
									<th>协会名称</th>
									<th>所属产业</th>
									<th>所在地</th>
									<th>企业数</th>
									<th>编辑</th>
								</tr>
								<tr v-for="(list,index) in associationData" :key="index">
									<td>{{index+1}}</td>
									<td><span class="title onlinetitle" @click="routerlinkid('/associationDetail',list.id)">{{list.title}}</span></td>
									<td>{{list.notion}}</td>
									<td>{{list.cityText}}</td>
									<td>{{list.enterpriseNum}}</td>
									<!-- <td class="collectfont1"><span  @click="listToggleCollect(list)">{{list.collectId == 0?'加入':'取消'}}关注</span></td> -->
									<td><span class="curp"		@click="listToggleCollect(list)">{{list.collectId == 0?'加入':'取消'}}关注</span></td>
							 
								</tr>  
							</table>
							<!-- 商会 -->
							<table border="0" cellspacing="0" cellpadding="0" class="enterprise_table" v-show="collecttype == 15">
								<tr>
									<th class="xuhaotd">序号</th>
									<th>商会名称</th>
									<th>家乡</th>
									<th>所在地</th>
									<th>企业数</th>
									<th>关注</th>
								</tr>
								<tr v-for="(list,index) in commerceDate" :key="index">
										<td>{{index+1}}</td>
									<td><span class="title onlinetitle" @click="routerlinkid('/commerceDetail',list.id)">{{list.title}}</span></td>
									<td>{{list.hometown}}</td>
									<td>{{list.cityText}}</td>
									<td>{{list.enterpriseNum}}</td>
									<!-- <td class="collectfont1"><span  @click="listToggleCollect(list)">{{list.collectId == 0?'加入':'移除'}}关注</span></td> -->
									<td><span class="curp"		@click="listToggleCollect(list)">{{list.collectId == 0?'加入':'取消'}}关注</span></td>
								</tr> 
							</table>
							<!-- 专业镇 --> 
							<table border="0" cellspacing="0" cellpadding="0" class="enterprise_table" v-show="collecttype == 19">
								<tr>
									<th class="xuhaotd">序号</th>
									<th>专业镇</th>
									<th>专业</th>
									<th>所属产业</th>
									<th>所在地</th>
									<th>企业数</th>
									<th>关注</th>
								</tr> 
								<tr v-for="(list,index) in townlist"  :key="index">
									<td>{{index+1}}</td>
									<td v-if="userdata.groupType == 0"><span :class="list.locking?'title onlinetitle td_locktitle locking':'title onlinetitle td_locktitle unlock'" @click="pagelockfun(list.id,list.locking)">{{list.town}}</span><span :class="list.locking?'td_lockimg locking':'td_lockimg unlock'	"></span></td>
									<td v-if="userdata.groupType > 0"><span  class="title onlinetitle" @click="routerlinkid(currentHref,list.id)">{{list.town}}</span></td>
									<td>{{list.title}}</td>
									<td>{{list.notion}}</td>
									<td>{{list.area}}</td>
									<td>{{list.enterpriseNum}}</td>
										<td><span class="curp"		@click="listToggleCollect(list)">{{list.collectId == 0?'加入':'取消'}}关注</span></td>
								</tr> 
							</table>
						</div>
						
					</div>
					  
					
				</div>
				<div v-else>
					<div class="heightVh95 whitebox container-flex-center">
						<freeUserTips :type="4" :bgtype="0"></freeUserTips>
					</div> 
				</div>
			</div>
		</div>
		<iframe :src='iframeurl' style="width: 1px;height: 1px;" frameborder="none" id="exportIframe"></iframe>
	</div>
</template>

<script>
	import { mapState, mapMutations, mapGetters } from "vuex";
	export default {
		name: 'mapserch',
		computed: {
		...mapState({
		// isCollapse: (state) => state.app.isCollapse,
		isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])
		},
		data() {
			return {
				title:"目标企业库", 
				userdata:{},curWebsite:this.$api.getWebsiteType(),  	collectPageType:0,collecttype:0,tabbtn: 0, 	shortListNum:0,longListNum: 0,
				orderField: 16, //排序字段 16 招商算法分数 1 时间
				orderType: 0, //排序方式 0 降序 1 升序 
			//龙头企业 1， 创新企业 2， 投资机构3，研究院4，资讯：5，专题：6，产业链：7，事件链：8，政策链：9，优质企业10，普通企业11，园区12，上市公司13， 
				tabtitle: [
				{name:'全部企业',tipsname:"企业",ctype:0,num:0,list:[]},
				{name:'上市公司',tipsname:"企业",ctype:13,num:0,list:[]},
				{name:'龙头企业',tipsname:"企业",ctype:1, num:0,list:[]}, 
				{name:'创新企业',tipsname:"企业",ctype:2,num:0,list:[]},
				{name:'优质企业',tipsname:"企业",ctype:10,num:0,list:[]},
				{name:'外资企业',tipsname:"外资企业",ctype:16,num:0,list:[]},
				{name:'境外上市企业',tipsname:"境外上市企业",ctype:18,num:0,list:[]},
				{name:'投资机构',tipsname:"投资机构",ctype:3,num:0,list:[]},
				{name:'科研机构',tipsname:"科研机构",ctype:4,num:0,list:[]}, 
				{name:'产业园区',tipsname:"产业园区",ctype:12,num:0,list:[]},
				{name:'协会',tipsname:"协会",ctype:14,num:0,list:[]},
				{name:'商会',tipsname:"商会",ctype:15,num:0,list:[],},
				{name:'专业镇',tipsname:"专业镇",ctype:19,num:0,list:[],}, 
				// {name:'产业链',tipsname:"产业链",ctype:7,num:0,list:[],}, 
				], //1,2,3,4{name:'科研机构',tipsname:"科研机构",ctype:4,num:0,list:[]},
			 yuanquTabName:"&上市公司&龙头企业&创新企业&优质企业&外资企业&投资机构&科研机构",
				xindaiTabName:"&上市公司&龙头企业&创新企业&优质企业&外资企业&投资机构&境外上市企业",
				touziTabName:"&创新企业&优质企业&上市公司&龙头企业&境外上市企业&外资企业&投资机构&科研机构&产业园区",
				mapdata:[{name:"广东",value:20,data:[{name:"深圳市",value:15}]},{name:"北京",value:50,data:[{name:"朝阳区",value:30}]},],flag:false,
				// 0=分数,1=融资时间,2=企业实力,3=投资力度,4=本省关联度,5=拿地数量,6=拿地面积,7=拿地金额,8=投资项目数量,9=投资项目金额,10=控制企业数量,11=专利数量 16=招商算法总分
				dimensionList: [{
					name: '综合',
					type: 0
				}, {
					name: '融资时间',
					type: 1
				},{
					name: '企业实力',
					type: 2
				}, {
					name: '投资力度',
					type: 3
				}, {
					name: '本省关联度',
					type: 4
				}, {
					name: '拿地数量',
					type: 5
				}, {
					name: '拿地面积',
					type: 6
				}, {
					name: '拿地金额',
					type: 7
				}, {
					name: '投资项目数量',
					type: 8
				}, {
					name: '投资项目金额',
					type: 9
				},], 
				dimesmlist:[{
					name: '总体评分',
					type: 16
				}, {
					name: '企业实力',
					type: 2
				}, {
					name: '投资力度',
					type: 3
				}, {
					name: '拿地数量',
					type: 5
				}, {
					name: '拿地面积',
					type: 6
				}, {
					name: '投资项目数量',
					type: 8
				}, {
					name: '投资项目金额',
					type: 9
				},],
				enternum:0,
				// ,{name:'控制企业数量',type:10},{name:'专利数量',type:11},{name:'营业收入（亿元）',type:12},{name:'营收增速',type:13},{name:'净利润（亿元）',type:14},{name:'净利增速',type:15},
				
				// collecttype: [{
				// 	name: "产业机会",
				// 	type: 0
				// }, {
				// 	name: '龙头企业',
				// 	type: 1
				// }],
				chainlist: [],
				entercommlist:[],
				shortenterlist:[],//短名单
				academylist: [], //创新资源
				orglist: [], //投资机构
				topiclist: [], //专题 
				eventchain: [], //事件链
				policychain: [], //政策链 
				parkdata:[],//产业园区
				associationData:[],//协会
				commerceDate:[],//商会
				forcapenterlist:[],//外资企业
				foreignEnterList:[],//境外上市企业
				townlist:[],//专业镇
				tipstext: '企业',
				tipsnum: 0,
				exportbtn: true, //导出按钮是否可用
				iframeurl: '',
				exportLoading: false, //导出loading
			}
		},
		created() {
			this.$nextTick(() => {
				// 禁用右键
				document.oncontextmenu = new Function("event.returnValue=false");
				// 禁用选择
				document.onselectstart = new Function("event.returnValue=false");
			});
			if(this.curWebsite.type == 3){
				this.tabtitle=this.tabtitle.filter(list=>{
					return this.yuanquTabName.indexOf(list.name)>0;
				});
			}else if(this.curWebsite.type == 4){
			this.tabtitle=this.tabtitle.filter(list=>{
				return this.xindaiTabName.indexOf(list.name)>0;
			});
			}else if(this.curWebsite.type == 5){ 
				this.tabtitle=this.tabtitle.filter(list=>{
					return this.touziTabName.indexOf(list.name)>0;
				});
			}
		 
		},
		mounted() {
			document.getElementById('app').style.background = "#f0f3f5";
			this.userdata = this.getuseriformation(); 
			if(this.userdata.token){
				this.getcollectlist(this.collectPageType,0);  

			}
		},
		methods: { 
			//导出数据
			exportlistFun() {
				
				var _this = this;
				let shortList = this.collectPageType == 'shortlist' ? 1 : 0;
				var ajaxurl = this.$api.cyl.collect.export() + '?shortList=' + shortList+ '&token=' + this.userdata
				.token;
				this.confirmtext = "导出中";
				var iframe = document.getElementById("exportIframe");
				iframe.setAttribute("src", ajaxurl);
				this.exportLoading = true;
				setTimeout(() => {
					_this.exportLoading = false;
				}, 5000)


			},
			//页面短名单和长名单切换
			collectPageToggle(type){
				this.collectPageType=type;
				if(type == 'shortlist'){
					this.getcollectlist(this.collectPageType);
				}else{
					this.getcollectlist(this.collectPageType,this.tabbtn);
				}
				
			},
			//tab栏切换
			tabbtnfun(list,index){
				if(this.collecttype!=list.ctype){
						this.tabbtn=index;this.collecttype=list.ctype;
					 if(list.ctype==0||list.ctype==1 || list.ctype==2 || list.ctype==10 || list.ctype==13 || list.ctype==16){ 
							this.tipsnum=this.enternum; 
						}else{ 
							// if(list.ctype==99){ 
							// }
								this.tipsnum=list.num;  
						};
						this.getcollectlist(list.ctype,index);
						this.tipstext=list.tipsname;
				} 
			},
			//时间/分数升降序
			tablesort(field) {
				if (field == this.orderField) {
					this.orderType = Math.abs(this.orderType - 1);
				} else {
					this.orderField = field;
				}
				this.getcollectlist(this.collectPageType,this.tabbtn);
				// this.ajaxsearchcompany();
			},
			//查询是否在crm项目管理中
				crmSearch(enterpiseIdList) {
					//把企业id转换成字符串
					return new Promise((resolve, reject) => {
						var enterpiseId = enterpiseIdList.join(',');
						this.$axios.get(this.$api.crm.enterprise.isExist2() + "?codeList=" + enterpiseId, { headers: { AuthToken: this.userdata.token } }).then(function (res) {
							if (res.data.success) {
								console.log('查询是否在crm项目管理中',res.data.data);
								let resdata = res.data.data;
								resolve(resdata);
							}
						})
					})
				},
			//获取各种类型的收藏列表
			getcollectlist(type,indexd) {
					// console.log('获取各种类型的收藏列表',type); 
				this.bus.$emit('loading',true); 
				var _this = this;var tabind=this.tabbtn;
				if(type == 'shortlist'){
					var ajaxurl = this.$api.cyl.collect.list() + '?shortList=1&pageSize=50&page=1&orderField='+this.orderField+'&orderType='+this.orderType; 
					this.$axios.get(ajaxurl, {
						headers: {AuthToken: this.userdata.token}
					}).then(function(res) { 
						if (res.data.success) {
							var enterlist = res.data.list ? res.data.list : [];  
					  _this.shortenterlist=enterlist;
							_this.shortListNum=enterlist.length;
							_this.bus.$emit('loading',false); 
						} else {
							
						}
					}).catch(function(error) {
						// console.log('错误',error);//请求失败处理 
					}); 
					
				}else {
					var ajaxurl = this.$api.cyl.collect.list() + '?type=' + type + '&pageSize=50&page=1&orderField='+this.orderField+'&orderType='+this.orderType;
				 
					this.$axios.get(ajaxurl, {
						headers: {AuthToken: this.userdata.token}
					}).then(function(res) {
						// console.log(type,res.data); 
						if (res.data.success) {
							var enterlist=[];
							if(res.data.list!=null){
								var enterlist = res.data.list.filter(list=>{
									return list.collectId>0;
								}); 
							}  
							let enterpriseIdList = [];
							for (var i = 0; i < res.data.list.length; i++) {
								enterpriseIdList.push(enterlist[i].stockCode);
								 
							}
							//处理是否在crm系统中
						_this.crmSearch(enterpriseIdList).then(res => {

							// 合并 crmId 到 dataenterlist
							_this.enterlist = enterlist.map(item => {
								console.log(res[item.stockCode]);
								return {
									...item,
									crmId: res[item.stockCode], // 如果没有匹配到，默认 crmId 为 0
								};
							})
						})
							_this.bus.$emit('loading',false);    
							let numarr=res.data.data,enterlistNum=0; //存储tab数值
							for(var i=0;i<numarr.length;i++){ 
								// if(numarr[i].type != 11){
								// 	 enterlistNum+=numarr[i].count; //长名单企业总数 type=11不知道是什么 剔除
								// }  
								for(var d=0;d<_this.tabtitle.length;d++){
									if(numarr[i].type == _this.tabtitle[d].ctype){
										_this.tabtitle[d].num=numarr[i].count;
										enterlistNum+=numarr[i].count;
									} 
								} 
							}
							_this.shortListNum=res.data.extend;
							_this.longListNum=enterlistNum;
							// _this.tabtitle[0].num=res.data.extend;
							if (type == 7) {
								_this.chainlist = enterlist;
							} else if (type == 1 || type == 2 || type == 13 || type == 10 || type == 0) { 
						 
								if(type !=16 && type != 18){
									_this.tabtitle[indexd].list=enterlist;
								} 
							}else if(type == 3){
								_this.orglist = enterlist;
							}else if(type == 4){
								for (var i = 0; i < enterlist.length; i++) {
									enterlist[i].notionlist = _this.taglistfun(enterlist[i].notion, enterlist[i].notionCode);
									enterlist[i].taglist = _this.taglistfun(enterlist[i].tag, enterlist[i].tagCode); 
								} 
								_this.academylist = enterlist;
							} else if (type == 6) {
								_this.topiclist = enterlist;
							} else if (type == 8) {
								_this.eventchain = enterlist;
							} else if (type == 9) {
								_this.policychain = enterlist;
							} else if(type  == 12){
								_this.parkdata=enterlist;
							}else if (type == 14){
								_this.associationData=enterlist;
							}else if(type == 15){
								_this.commerceDate=enterlist;
							}else if (type == 16){ 
								_this.forcapenterlist=enterlist;  
							}else if(type == 18){ 
								_this.foreignEnterList=enterlist;
							}else if(type == 19){
								_this.townlist=enterlist; 
							}
							console.log(type,'原始',res.data)
							console.log('筛选后',enterlist)
							// console.log(_this.tipstext,type,enterlist)
							_this.bus.$emit('loading',false); 
						} else {
						_this.bus.$emit('loading',false);
							
						}
					}).catch(function(error) {
						_this.bus.$emit('loading',false);
						// console.log('错误',error);//请求失败处理 
					});
				}
   // console.log(this.tabtitle)
			},
			//取消收藏
			cancelcollect(id,list,enterpriseType) { 
				// console.log(id.list)
				var _this = this; 
				var tabdg=this.tabtitle[this.tabbtn];
				// console.log(list); 
				$.ajax({
					type: "POST",
					url: this.$api.cyl.collect.remove(),
					data: {
						collectId: id
					},
					headers: {
						AuthToken: this.userdata.token
					},
					success: function(res) {
						if (res.success) {
							list.collectId=0;
							tabdg.num=tabdg.num-1;
							_this.$message({type:'success',message:"已取消对该企业的关注"});
						 
						}
					}
				})
			}, 
			//加入移除短名单
			shortlistToggle(collectid,shorttype,list){ 
				var ajaxurl=""
				if(shorttype<1){
					ajaxurl=this.$api.cyl.collect.addshortList() 
				}else if(shorttype == 1){
						ajaxurl=this.$api.cyl.collect.removeshortList() 
				}
				var _this = this;
				$.ajax({
					type: "POST",
					url: ajaxurl,
					data: {
						collectId: collectid
					},
					headers: {
						AuthToken: this.userdata.token
					},
					success: function(res) {
						if (res.success) {
						 // console.log(123,res.data);
							if(_this.collectPageType == 'shortlist'){
								list.collectId=0;
							}else{
								list.shortList=Math.abs(shorttype-1); 
								// if(shorttype<1){
								// 	_this.tabtitle[0].num=_this.tabtitle[0].num+1;
								// }else{
								// 	_this.tabtitle[0].num=_this.tabtitle[0].num-1;
								// } 
							}
							_this.$message({type:'success',message:"操作成功"})
					 
						}
					}
				})
			},
			//加入移除项目管理
			crmtoggle(data,enterpiseid){
				// console.log(data);
				var _this=this;  
				if(data.crmId ==0){ 
				this.$axios.get(this.$api.crm.enterprise.addtoCRM()+"?stockCode="+enterpiseid,{headers:{AuthToken:this.userdata.token}}).then(function(res){
					console.log("添加到CRM库",res);   
					if(res.data.success){  
							data.crmId = res.data.data.id;
						_this.$message({
							type: 'success',
							message: '已加入项目管理',
						});
					} 
				}).catch(function (error) {
					// 请求失败处理 console.log(error);
				});
				}else{
					 console.log('移除',data.crmId)
					$.ajax({
						type:"POST",
						url:this.$api.crm.customer.delete(),
						data:{id:data.crmId}, 
						headers:{AuthToken:this.userdata.token },
						success:function(res){ 
							console.log(res) 
							if(res.success){
								data.crmId = 0; 
								_this.$message({
									type: 'success',
									message: '已移除项目管理',
								});
							}else{
								_this.$message({type:"error",message:res.msg})
							}
						} 
					}) 
				}
			},
 
			
		},
	}
</script>

<style>

</style>
